// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a95fd57f","453":"77aef9b5","732":"8a162740","977":"8aa52dfc"}[chunkId] + ".chunk.js";
};